export default __webpack_public_path__ + "static/media/electricty.e7373558.svg";